import { render, staticRenderFns } from "./EbooksCustom.vue?vue&type=template&id=56cb4b2c"
import script from "./EbooksCustom.vue?vue&type=script&lang=js"
export * from "./EbooksCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports